<template>
  <v-layout class="pa-2 pr-6">
    <v-flex>
      <v-toolbar flat>
        <h3 class="font-weight-light black--text" v-if="!getVenda.id">Venda</h3>
        <h3 class="font-weight-light black--text" v-else>
          Editando Venda {{ getVenda.id }}
        </h3>

        <v-spacer></v-spacer>
        <v-text-field
          v-model="created_at"
          label="Data"
          id="id"
          outlined
          dense
          hide-details
          class="ml-2 mr-2"
          type="date"
          v-if="$helper.verificaPermissao('seleciona-data-venda') && !getVenda.id"
        ></v-text-field>
        <v-autocomplete
          :items="getFuncionarios"
          label="Vendedor"
          class="autocomplete-vendedor mr-2"
          hide-details
          outlined
          v-model="getFuncionario.id"
          dense
          item-text="nome_abreviado"
          item-value="id"
          width="50"
          id="input-vendedor"
        ></v-autocomplete>
        <v-btn
          color="success"
          class="mr-2 white--text"
          @click="fecharVenda"
          outlined
          id="btn-fechar-venda"
          >Fechar Venda (F5)</v-btn
        >
        <v-btn
          v-if="getVenda.id"
          color="primary"
          class="white--text"
          @click="cadastrarVenda(), $router.push({ name: 'vendaCadastro' })"
          outlined
          >Nova Venda</v-btn
        >
        <!-- <v-btn v-if="getVenda.id" color="warning" class="ml-2" @click="visualizarVenda(getVenda)" outlined> Imprimir</v-btn> -->

        <v-menu bottom left transition="slide-y-transition" class="ml-10 mr-10">
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-bind="attrs" v-on="on">
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item
              @click="cadastrarProduto"
              v-if="$helper.verificaPermissao('cadastrar-produto')"
            >
              <v-list-item-action>
                <v-icon>window</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Cadastrar Produto</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item
              @click="cadastrarContato"
              v-if="$helper.verificaPermissao('cadastrar-contato')"
            >
              <v-list-item-action>
                <v-icon>perm_identity</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Cadastrar Contato</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item
              @click="setModalListarVenda(true)"
              v-if="$helper.verificaPermissao('venda-troca-mercadoria')"
            >
              <v-list-item-action>
                <v-icon>compare_arrows</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Trocar Mercadoria</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item
              @click="setModalListarLancamentoCaixa(true)"
              v-if="$helper.verificaPermissao('visualizar-lancamento-caixa')"
            >
              <v-list-item-action>
                <v-icon>attach_money</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Lancamentos</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-toolbar>
      <v-container :fluid="true" class="ml-2 mr-2">
        <!-- <v-layout row wrap> -->
        <v-card outlined>
          <v-layout row wrap class="pl-5 pr-5 pt-5">
            <v-flex xs12 md2>
              <v-text-field
                dense
                outlined
                v-model="codigo_barras"
                type="number"
                id="codigo_barra"
                label="Código"
                class="ml-1 mr-1"
                @keyup.enter="pesquisarProdutoPorCodigoDeBarras()"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md5>
              <v-text-field
                dense
                v-model="getProdutoVenda.descricao"
                label="Produto"
                readonly
                outlined
                class="ml-1 mr-1"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md1>
              <v-text-field
                dense
                outlined
                v-model="getProdutoVenda.preco_venda"
                type="text"
                @blur="somaTotalItem"
                label="P. Unit."
                class="ml-1 mr-1"
                @keyup.13="focusQuantidade"
                id="preco_unitario"
                v-mask="[
                  '#,##',
                  '##,##',
                  '###,###',
                  '#.###,##',
                  '##.###,##',
                  '###.###,##',
                ]"
                @click="$event.target.select()"
                :readonly="$helper.verificaPermissao('alterar-preco-produto-venda') == true ? false : true || (getProdutoVenda.tipo == 'SERVIÇO' ? false : true)"
              >
              </v-text-field>
            </v-flex>
            <v-flex xs12 md1>
              <v-text-field
                dense
                outlined
                v-model="quantidade"
                type="text"
                @blur="somaTotalItem"
                label="Quantidade"
                id="quantidade"
                @keyup.13="focusDescontoUnitario"
                class="ml-1 mr-1"
                v-mask="[
                  '#,##',
                  '##,##',
                  '###,###',
                  '#.###,##',
                  '##.###,##',
                  '###.###,##',
                ]"
                @click="$event.target.select()"
              >
              </v-text-field>
            </v-flex>
            <v-flex xs12 md1>
              <v-text-field
                dense
                outlined
                v-model="desconto"
                type="text"
                label="Desc. %"
                @keyup.13="addItemVenda"
                class="ml-1 mr-1"
                id="desconto_unitario"
                v-mask="[
                  '#,##',
                  '##,##',
                  '###,###',
                  '#.###,##',
                  '##.###,##',
                  '###.###,##',
                ]"
                @click="$event.target.select()"
              >
              </v-text-field>
            </v-flex>
            <v-flex xs12 md2>
              <v-text-field
                dense
                outlined
                v-model="total"
                type="text"
                label="Total"
                @keyup.13="addItemVenda"
                class="ml-1 mr-1"
                readonly
                v-mask="[
                  '#,##',
                  '##,##',
                  '###,###',
                  '#.###,##',
                  '##.###,##',
                  '###.###,##',
                ]"
              >
                <template v-slot:append-outer>
                  <v-icon id="btn-add-produto" @click="addItemVenda">control_point</v-icon>
                </template>
              </v-text-field>
            </v-flex>
          </v-layout>
          <v-card-text class="mt-0">
            <hr />
            <v-simple-table dense fixed-header height="250px">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">Código</th>
                    <th width="65%" max-width="65%" class="text-left">
                      Descrição
                    </th>
                    <th class="text-left">P. Unit.</th>
                    <th class="text-left">Quantidade</th>
                    <th class="text-left">Subtotal</th>
                    <th class="text-left">Desconto</th>
                    <th class="text-left">Total</th>
                    <th class="text-left"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr class="error" v-if="getProdutosTroca.length > 0">
                    <td colspan="8">
                      <p class="white--text text-center mt-4">
                        <b>PRODUTOS DEVOLVIDOS</b>
                      </p>
                    </td>
                  </tr>
                  <tr class="error" v-for="p in getProdutosTroca" :key="p.id">
                    <td class="text-left white--text">{{ p.produto_id }}</td>
                    <td class="text-left white--text">{{ p.descricao }}</td>
                    <td class="text-left white--text">{{ p.preco_venda }}</td>
                    <td class="text-left white--text">
                      {{
                        $helper.formatReal(parseFloat(p.quantidade_devolvida))
                      }}
                    </td>
                    <td class="text-left white--text">
                      {{
                        $helper.formatReal(parseFloat(p.preco_venda_devolucao))
                      }}
                    </td>
                    <td class="text-left white--text">0,00</td>
                    <td class="text-left white--text">
                      {{
                        $helper.formatReal(parseFloat(p.preco_venda_devolucao))
                      }}
                    </td>
                    <td>
                      <v-btn
                        color="default"
                        class="white--text"
                        x-small
                        outlined
                        @click="removeProdutoTroca(p)"
                      >
                        <v-icon>delete_forever</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                  <tr v-for="p in getProdutosVenda" :key="p.id">
                    <td>{{ p.produto_id }}</td>
                    <td>{{ p.descricao }}</td>
                    <td>{{ $helper.formatReal(parseFloat(p.preco)) }}</td>
                    <td>{{ $helper.formatReal(parseFloat(p.quantidade)) }}</td>
                    <td>{{ $helper.formatReal(parseFloat(p.subtotal)) }}</td>
                    <td>{{ $helper.formatReal(parseFloat(p.desconto)) }}</td>
                    <td>{{ $helper.formatReal(parseFloat(p.total)) }}</td>
                    <td>
                      <v-btn
                        color="error"
                        x-small
                        outlined
                        @click="removerItemVenda(p)"
                      >
                        <v-icon>delete_forever</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
            <hr />
            <v-simple-table dense>
              <template v-slot:default>
                <tbody>
                  <tr>
                    <td class="text-md-right text-xs-right">
                      <strong>Subtotal</strong>
                    </td>
                    <td width="10%">
                      <strong>{{ getVenda.subtotal }}</strong>
                    </td>
                  </tr>
                  <tr>
                    <td class="text-md-right text-xs-right">
                      <strong>Desconto</strong>
                    </td>
                    <td width="10%">
                      <strong>{{ getVenda.desconto }}</strong>
                    </td>
                  </tr>
                  <tr
                    v-if="getVenda.saldo_troca && $helper.cleanFormatReal(getVenda.saldo_troca) > 0"
                  >
                    <td class="text-md-right text-xs-right">
                      <strong>Saldo referente a troca de mercadoria</strong>
                    </td>
                    <td width="10%">
                      <strong>{{ getVenda.saldo_troca }}</strong>
                    </td>
                  </tr>
                  <tr>
                    <td class="text-md-right text-xs-right">
                      <strong>Total</strong>
                    </td>
                    <td width="10%">
                      <strong>{{ getVenda.total }}</strong>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
            <span v-if="getContato.id">
              <hr />
              <v-layout row wrap class="pt-4 pl-1 pr-1">
                <v-flex xs12 md2>
                  <v-text-field
                    dense
                    outlined
                    @input="debouncedBuscarContato"
                    v-model="getContato.id"
                    label="Código do Cliente"
                    type="number"
                    class="ml-1 mr-1"
                    @keyup.13="debouncedBuscarContato"
                    id="codigo_cliente"
                    append-outer-icon="edit"
                    @click:append-outer="visualizarContato(getContato.id)"
                  >
                  </v-text-field>
                </v-flex>
                <v-flex
                  xs12
                  md12
                  v-if="
                    getContato.tipo_pessoa == 'Pessoa Física' && getContato.cpf
                  "
                >
                  <v-text-field
                    dense
                    outlined
                    v-model="getContato.cpf"
                    label="CPF"
                    disabled
                    class="mr-1 ml-1"
                  ></v-text-field>
                </v-flex>
                <v-flex
                  xs12
                  md12
                  v-if="
                    getContato.tipo_pessoa == 'Pessoa Jurídica' &&
                    getContato.cnpj
                  "
                >
                  <v-text-field
                    dense
                    outlined
                    v-model="getContato.cnpj"
                    label="CPF"
                    disabled
                    class="mr-1 ml-1"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md10>
                  <v-text-field
                    dense
                    outlined
                    v-model="getContato.nome"
                    label="Nome"
                    class="mr-1 ml-1"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md3>
                  <v-text-field
                    dense
                    outlined
                    v-model="getContato.cep"
                    label="CEP"
                    disabled
                    class="mr-1 ml-1"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md6>
                  <v-text-field
                    dense
                    outlined
                    v-model="getContato.logradouro"
                    label="Logradouro"
                    disabled
                    class="mr-1 ml-1"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md3>
                  <v-text-field
                    dense
                    outlined
                    v-model="getContato.numero"
                    label="Número"
                    disabled
                    class="mr-1 ml-1"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md3>
                  <v-text-field
                    dense
                    outlined
                    v-model="getContato.bairro"
                    label="Bairro"
                    disabled
                    class="mr-1 ml-1"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md3>
                  <v-text-field
                    dense
                    outlined
                    v-model="getContato.cidade"
                    label="Cidade"
                    disabled
                    class="mr-1 ml-1"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md3>
                  <v-text-field
                    dense
                    outlined
                    v-model="getContato.uf"
                    label="UF"
                    disabled
                    class="mr-1 ml-1"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md3>
                  <v-text-field
                    dense
                    outlined
                    v-model="getContato.complemento"
                    label="Complemento"
                    disabled
                    class="mr-1 ml-1"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </span>
          </v-card-text>
        </v-card>

        <h4 class="mt-5">
          F2 - Pesquisar Produto / F3 - Pesquisar Cliente / F5 - Fechar a Venda / F6 - Desconto
        </h4>
      </v-container>
    </v-flex>

    <v-dialog v-model="modalSalvar" max-width="720">
      <v-card>
        <v-card-title>Fechar</v-card-title>
        <v-card-text>
          <h1 align="center" v-if="getVenda.troco > 0">
            TROCO: {{ $helper.formatReal(parseFloat(getVenda.troco)) }}
          </h1>
          <h4 v-if="getVenda.saldo_troca && getTroca.venda_id && $helper.cleanFormatReal(getVenda.saldo_troca) > $helper.cleanFormatReal(getVenda.subtotal)" align="center">
            O saldo restante de
            <strong>R$ {{ $helper.formatReal($helper.cleanFormatReal(getVenda.saldo_troca) - $helper.cleanFormatReal(getVenda.subtotal)) }}</strong> desta troca será armazenado no cadastro do cliente.
          </h4>
          <h3 align="center" class="mt-4">
            Tem certeza que deseja fechar esta venda?
          </h3>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="default"
            @click="cancelarFechamento(), (modalSalvar = false)"
            outlined
            :loading="$store.getters.getOverlay"
            >Não (N)</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn
            color="success"
            @click="salvar()"
            @dblclick="salvar()"
            outlined
            :loading="$store.getters.getOverlay"
            >Sim (S)</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="modalFechamento" persistent v-if="modalFechamento">
      <v-card>
        <v-card-title>Fechar Venda</v-card-title>
        <v-card-text>
          <v-layout row wrap>
            <v-flex xs12 md6>
              <v-form ref="formFormaPagamento">
                <v-layout row wrap class="mr-2 ml-2 mt-8">
                  <v-flex xs12 md8>
                    <v-select
                      label="Forma de Pagamento"
                      :items="getFormasPagamento"
                      v-model="formaPagamentoSelecionada"
                      return-object
                      outlined
                      dense
                      item-text="id"
                      item-value="id"
                      class="mr-1 ml-1"
                      id="inputFormaPagamento"
                      :rules="rules.formaPagamentoSelecionada"
                      :hide-selected="true"
                      @keyup.13="focus('inputValorPago')"
                      @input="verificarAcrescimo($event)"
                      no-data-text="Forma de pagamento não encontrada."
                    >
                      <template v-slot:item="{ item }">
                        {{ item.id }} - {{ item.nome }}
                      </template>
                      <template v-slot:selection="{ item }">
                        {{ item.id }} - {{ item.nome }}
                      </template>
                    </v-select>
                  </v-flex>
                  <v-flex xs12 md3>
                    <v-text-field
                      v-if="formaPagamentoSelecionada.id"
                      dense
                      outlined
                      type="text"
                      v-model="formaPagamentoSelecionadaValor"
                      label="Valor Pago"
                      @keyup.13="
                        formaPagamentoSelecionada.prazo
                          ? focus('inputRecorrencia')
                          : adicionaPagamento()
                      "
                      :rules="rules.formaPagamentoSelecionadaValor"
                      id="inputValorPago"
                      class="mr-1 ml-1"
                      v-mask="[
                        '#,##',
                        '##,##',
                        '###,###',
                        '#.###,##',
                        '##.###,##',
                        '###.###,##',
                      ]"
                      @click="$event.target.select()"
                    >
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12 md8>
                    <v-autocomplete
                      v-model="bandeira_cartao"
                      :items="formaPagamentoSelecionada.bandeiras_cartao"
                      v-if="formaPagamentoSelecionada.bandeiras_cartao"
                      item-text="nome"
                      item-value="id"
                      class="mr-1 ml-1"
                      outlined
                      dense
                      label="Bandeira do Cartão"
                      :rules="rules.bandeira_cartao"
                      return-object
                    />
                  </v-flex>

                  <v-flex xs12 md3>
                    <v-autocomplete
                      v-model="numero_parcelas"
                      :items="numero_parcelas_opcoes"
                      v-if="numero_parcelas_opcoes.length > 0"
                      item-text="nome"
                      item-value="id"
                      class="mr-1 ml-1"
                      outlined
                      dense
                      :rules="rules.numero_parcelas"
                      label="Quant. de Parcelas"
                      @keyup.13="adicionaPagamento"
                    />
                  </v-flex>
                  <v-flex xs12 md8>
                    <v-autocomplete
                      v-model="formaPagamentoSelecionada.recorrencia"
                      :items="getRecorrenciasFormaPagamento"
                      :rules="rules.recorrencia"
                      item-text="descricao"
                      item-value="dias"
                      label="Recorrência"
                      v-if="formaPagamentoSelecionada.prazo"
                      id="inputRecorrencia"
                      outlined
                      dense
                      @keyup="focus('inputNumeroParcelasPrazo', event)"
                      return-object
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex xs12 md3>
                    <v-text-field
                      label="Número de Parcelas"
                      outlined
                      dense
                      v-model="numero_parcelas"
                      :rules="rules.numero_parcelas"
                      id="inputNumeroParcelasPrazo"
                      class="mr-1 ml-1"
                      type="number"
                      @keyup.enter="adicionaPagamento"
                      v-if="formaPagamentoSelecionada.prazo"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md12>
                    <ul>
                      <li v-for="f in getFormasPagamento" :key="f.id">
                        {{ f.id }} - {{ f.nome }}
                      </li>
                    </ul>
                  </v-flex>
                </v-layout>
              </v-form>
            </v-flex>
            <v-flex xs12 md6>
              <v-simple-table
                fixed-header
                v-if="venda.formas_pagamento.length > 0"
              >
                <template v-slot:default>
                  <tbody>
                    <tr v-for="f in venda.formas_pagamento" :key="f.id">
                      <td class="display-1" width="50%">{{ f.forma }}</td>
                      <td class="display-1" width="50%">
                        {{ $helper.formatReal(parseFloat(f.valor_pago)) }}
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>

              <v-simple-table fixed-header class="mt-10">
                <template v-slot:default>
                  <tbody>
                    <!--<tr>
                      <td class="display-1" width="50%">SUBTOTAL</td>
                      <td class="display-1" width="50%">
                        {{
                          $helper.formatReal(
                            $helper.cleanFormatReal(getVenda.total) +
                              $helper.cleanFormatReal(getVenda.desconto) -
                              getVenda.acrescimo
                          )
                        }}
                      </td>
                    </tr> -->
                    <tr>
                      <td class="display-1" width="50%">SUBTOTAL</td>
                      <td class="display-1" width="50%">{{$helper.formatReal($helper.cleanFormatReal(getVenda.subtotal))}}</td>
                    </tr>
                    <tr>
                      <td class="display-1" width="50%">ACRÉSCIMO</td>
                      <td class="display-1" width="50%">
                        {{ $helper.formatReal(parseFloat(getVenda.acrescimo)) }}
                      </td>
                    </tr>
                    <tr>
                      <td class="display-1" width="50%">DESCONTO</td>
                      <td class="display-1" width="50%">
                        {{ getVenda.desconto }}
                      </td>
                    </tr>
                    <tr
                      v-if="getVenda.saldo_troca && $helper.cleanFormatReal(getVenda.saldo_troca) > 0"
                    >
                      <td class="display-1" width="50%">SALDO DA TROCA</td>
                      <td class="display-1" width="50%">{{ getVenda.saldo_troca }}</td>
                    </tr>
                    <tr>
                      <td class="display-1" width="50%">TOTAL</td>
                      <td class="display-1" width="50%">
                        {{ getVenda.total }}
                      </td>
                    </tr>
                    <tr>
                      <td class="display-1" width="50%">PAGO</td>
                      <td class="display-1" width="50%">
                        {{ $helper.formatReal(parseFloat(valorPago)) }}
                      </td>
                    </tr>
                    <tr v-if="valorFaltando > 0">
                      <td class="display-1" width="50%">FALTA</td>
                      <td class="display-1" width="50%">
                        {{ $helper.formatReal(parseFloat(valorFaltando)) }}
                      </td>
                    </tr>
                    <tr v-if="getVenda.troco > 0">
                      <td class="display-1" width="50%">TROCO</td>
                      <td class="display-1" width="50%">
                        {{ $helper.formatReal(parseFloat(getVenda.troco)) }}
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="warning"
            outlined
            dense
            @click="modalCancelarFechamento = true"
            >Cancelar Fechamento</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn color="success" @click="adicionaPagamento" outlined
            >Confirmar Fechamento</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="modalCancelarFechamento" persistent max-width="720px">
      <v-card outlined>
        <v-card-title>Cancelar Fechamento</v-card-title>
        <v-card-text>
          <h3 align="center">
            Os valores lançados serão apagados, tem certeza que deseja cancelar?
          </h3>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="default"
            outlined
            @click="modalCancelarFechamento = false"
            >Não (N)</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn
            color="warning"
            outlined
            @click="cancelarFechamento(), (modalFechamento = false)"
          >
            Sim (S)</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="modalAplicarAcrescimo" persistent max-width="720px">
      <v-card outlined>
        <v-card-title>Aplicar Acréscimo</v-card-title>
        <v-card-text v-if="parseFloat(formaPagamentoSelecionada.acrescimo) > 0">
          <h3 align="center">
            Esta forma de pagamento possui acréscimo de
            {{
              $helper.formatReal(
                parseFloat(formaPagamentoSelecionada.acrescimo)
              )
            }}%, deseja confirmar?
          </h3>
        </v-card-text>
        <v-card-actions>
          <v-btn color="default" outlined @click="modalAplicarAcrescimo = false"
            >Não (N)</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn color="warning" outlined @click="aplicarAcrescimo">
            Sim (S)</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <ModalCadastroContato v-if="getModalCadastroContato" />
    <ModalCadastroProduto v-if="getModalCadastroProduto" />
    <ModalpesquisarContato />
    <ModalImprimirVenda />
    <ModalListarLancamentoCaixa v-if="getModalListarLancamentoCaixa" />
    <Snackbar />
    <ModalTrocaVenda v-if="getModalTrocaVenda" />
    <ModalListarVenda v-if="getModalListarVenda" />
    <ModalAplicarDesconto />
    <ModalPesquisarProduto
      @focusInputQuantidade="focusQuantidade"
      v-if="getModalPesquisarProduto"
    />
    <ModalVisualizarVenda v-if="getModalVisualizarVenda" />
    <ModalListarGradeProduto :botaoAdicionarVenda="true" />
    <v-dialog
      v-model="modalAbateCreditoCliente"
      scrollable
      persistent
      max-width="500px"
      transition="dialog-transition"
    >
      <v-card>
        <v-card-title>Utilizar Crédito</v-card-title>
        <v-card-text>
          <h3 v-if="getContato.id && getContato.credito" align="center">
            Este cliente possui um crédito no valor de R$
            <strong>{{ $helper.formatReal(parseFloat(getContato.credito)) }}</strong>, deseja ultilizar?
          </h3>
        </v-card-text>
        <v-card-actions>
          <v-btn color="default" outlined @click="modalAbateCreditoCliente = false">Voltar</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="success"
            @click="adicionaPagamento(), modalAbateCreditoCliente = false"
            outlined
          >Sim</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Produto from "@/services/ProdutoService";
import FormaPagamento from "@/services/FormaPagamentoService";
import ModalCadastroContato from "@/pages/contato/ModalCadastro";
import ModalCadastroProduto from "@/pages/produto/ModalCadastro";
import ModalPesquisarProduto from "@/pages/produto/ModalPesquisarProduto";
import ModalpesquisarContato from "@/pages/contato/ModalPesquisar";
import ModalImprimirVenda from "@/pages/venda/ModalImprimir";
import ModalListarLancamentoCaixa from "@/pages/caixa/lancamento/Listar";
import Snackbar from "@/components/shared/Snackbar";
import ModalTrocaVenda from "@/pages/venda/ModalTrocaVenda";
import ModalListarVenda from "@/pages/venda/ModalListarVenda";
import ModalAplicarDesconto from "@/pages/venda/ModalDescontoAdicional";
import ModalVisualizarVenda from "@/pages/venda/ModalVisualizar";
import ModalListarGradeProduto from "@/pages/produto/grade/ModalListar"
import moment from "moment"

var _ = require("lodash");

export default {
  components: {
    ModalCadastroContato,
    ModalCadastroProduto,
    ModalPesquisarProduto,
    ModalpesquisarContato,
    ModalImprimirVenda,
    Snackbar,
    ModalListarLancamentoCaixa,
    ModalTrocaVenda,
    ModalListarVenda,
    ModalAplicarDesconto,
    ModalVisualizarVenda,
    ModalListarGradeProduto,
  },
  data() {
    return {
      produtos: [],
      contatos: [],
      formaPagamentoSelecionada: {
        id: "",
        nome: "",
        bandeiras_cartao: null,
        prazo: false,
      },
      formaPagamentoSelecionadaValor: "",
      formasPagamentosVenda: [],
      cliente_id: 1,
      produto_id: "",
      descricao: "",
      preco: "",
      subtotal: "",
      desconto: "",
      total: 0,
      codigo_barras: "",
      quantidade: 1,
      valorPago: 0,
      valorFaltando: 0,
      troco: 0,
      trocoFormaPagamento: 0,
      descontoAdicionalTotalVenda: "0,00",
      tabs: 0,
      valor_frete: 0,
      venda: {
        subtotal: 0,
        desconto: 0,
        total: 0,
        cliente_id: 1,
        itens: [],
        formas_pagamento: [],
      },
      vendedor_id: null,
      modalSalvar: false,
      modalFechamento: false,
      modalImprimir: false,
      modalCancelarFechamento: false,
      linkCupomNaoFiscal: "",
      rules: {
        nome: [(v) => !!v || "Campo obrigatório."],
        formaPagamentoSelecionada: [(v) => !!v || "Campo obrigatório."],
        formaPagamentoValor: [(v) => !!v || "Campo obrigatório."],
        bandeira_cartao: [(v) => !!v || "Campo obrigatório."],
        numero_parcelas: [(v) => !!v || "Campo obrigatório."],
        recorrencia: [(v) => !!v || "Campo obrigatório."],
      },
      showOpcoes: false,
      modalAplicarAcrescimo: false,
      acrescimosAplicados: [],
      contato_id: null,
      bandeira_cartao: "",
      numero_parcelas_opcoes: [],
      numero_parcelas: "",
      created_at: moment().format('YYYY-MM-DD'),
      modalAbateCreditoCliente: false
    };
  },
  watch: {
    descricao: function () {
      this.debouncedPesquisarPorDescricao();
    },
    // codigo_barras: function () {
    //   if (this.codigo_barras != "") {
    //     this.debouncedpesquisarProdutoPorCodigoDeBarras();
    //   }
    // },
    quantidade: function () {
      if (this.quantidade != "" && this.quantidade != 0) {
        this.somaTotalItem();
      }
    },
    contato_id: function () {
      if (this.contato_id != "" && this.contato_id != 0) {
        this.somaTotalItem();
      }
    },
    desconto: function () {
      this.aplicaDescontoItem();
    },
    formaPagamentoSelecionada() {
      this.numero_parcelas_opcoes = [];
      this.bandeira_cartao = "";
      this.numero_parcelas = "";
      if (this.formaPagamentoSelecionada.abate_credito_cliente) {
        if (this.getContato.id == null || this.getContato.id == "" || this.getContato.id == 1) {
          this.$store.commit(
            "snackbarWarning",
            "Informe um cliente para esta forma de pagamento."
          );
          this.formaPagamentoSelecionada = "";
          return;
        }

        if (this.getContato.credito > 0) {
          this.modalAbateCreditoCliente = true
          if (this.getContato.credito <= this.$helper.cleanFormatReal(this.valorFaltando)) {
            this.formaPagamentoSelecionadaValor = this.$helper.formatReal(parseFloat(this.getContato.credito))
          } else {
            this.formaPagamentoSelecionadaValor = this.valorFaltando
          }
        } else {
          this.$store.commit('snackbarError', 'Esse cliente não possui saldo, por favor selecione outra forma de pagamento.')
          this.formaPagamentoSelecionada = "";
        }

        if (this.getVenda.total < 0) {
          this.modalAdicionarCreditoCliente = true
        }
      }
    },
    bandeira_cartao: function () {
      this.numero_parcelas_opcoes = [];
      for (
        let index = 1;
        index <= this.bandeira_cartao.numero_maximo_parcelas;
        index++
      ) {
        this.numero_parcelas_opcoes.push(index);
      }
    },
    getModalPesquisarProdutosOrcamento() {
      if (
        this.getModalPesquisarProdutosOrcamento == false &&
        this.getProdutoVenda.id
      ) {
        setTimeout(() => {
          this.focusQuantidade();
        }, 100);
      }
    },
    getModalPesquisarContato() {
      if (this.getModalPesquisarContato == false) {
        setTimeout(() => {
          if (this.modalFechamento) {
            this.focus("inputFormaPagamento");
          }
        }, 100);
      }
    },
    getModalVisualizarVenda() {
      if (this.getModalVisualizarVenda == false) {
        this.cadastrarVenda();
      }
    },
  },
  computed: {
    ...mapGetters([
      "getContatos",
      // 'getContato',
      "getContato",
      "getProdutoVenda",
      "getFormasPagamento",
      "getVenda",
      "getProdutosVenda",
      "getFormaPagamento",
      "getDescontoTotalPercentualVenda",
      "getTroca",
      "getProdutosTroca",
      "getPermissaoFuncionario",
      "getRecorrenciasFormaPagamento",
      "getModalPesquisarProdutosOrcamento",
      "getModalPesquisarContato",
      "getFuncionarios",
      "getModalVisualizarVenda",
      "getFuncionario",
      "getModalCadastroContato",
      "getModalCadastroProduto",
      "getModalListarLancamentoCaixa",
      "getModalTrocaVenda",
      "getModalListarVenda",
    ]),
    itens() {
      return this.$store.getters.getItensVenda;
    },
  },
  methods: {
    ...mapActions([
      "cadastrarProduto",
      "buscarProduto",
      "pesquisarProduto",
      "setModalPesquisarProdutosOrcamento",
      "cadastrarContato",
      // "listarContatos",
      "setModalPesquisarContato",
      "listarFormaPagamento",
      "cadastrarVenda",
      "setModalExcluirVenda",
      "excluirVenda",
      "setClienteVenda",
      "addProdutoVenda",
      "removeProdutoVenda",
      "editarFormaPagamento",
      "editarVenda",
      "setProdutoVenda",
      "setModalImprimirVenda",
      "salvarVenda",
      "atualizarVenda",
      "setModalListarLancamentoCaixa",
      "setModalGerarNfe",
      "setDrawer",
      "setModalTrocaVenda",
      "removeProdutoTroca",
      "salvarTrocaVenda",
      "aplicaDescontoVenda",
      "setModalListarVenda",
      "buscarContato",
      "visualizarContato",
      "setModalDescontoAdicionalVenda",
      "setModalVisualizarVenda",
      "listarFuncionarios",
      "getModalPesquisarProduto",
      "visualizarVenda",
      "setModalListarGradeProduto",
    ]),
    salvar() {
      if (this.getFuncionario.id) {
        this.getVenda.funcionario_id = this.getFuncionario.id;
      }

      this.modalSalvar = false;
      this.modalFechamento = false;
      // this.getVenda.desconto = this.$helper.cleanFormatReal(this.getVenda.subtotal) - this.$helper.cleanFormatReal(this.getVenda.total);
      // this.getVenda.desconto_percentual = ((this.$helper.cleanFormatReal(this.getVenda.subtotal) - this.$helper.cleanFormatReal(this.getVenda.total)) / this.$helper.cleanFormatReal(this.getVenda.subtotal)) * 100;
      this.getVenda.itens = this.getProdutosVenda;
      this.getVenda.cliente_id = this.getContato.id;
      this.getVenda.subtotal = this.getVenda.subtotal;
      this.getVenda.valor_pago = this.valorPago;
      this.getVenda.total = this.getVenda.total;
      this.getVenda.troco = this.getVenda.troco;

      if (this.getTroca.venda_id && this.getProdutosTroca.length > 0) {
        let descontoTroca = 0
        this.getProdutosTroca.forEach(i => {
          descontoTroca = descontoTroca + i.preco_venda_devolucao
        })
        this.getVenda.desconto = this.$helper.formatReal(descontoTroca - this.$helper.cleanFormatReal(this.getVenda.saldo_troca))
      }

      //Verifica se existem produtos a serem trocados para que seja efetuado a troca.
      if (this.getProdutosTroca.length > 0) {
        this.getTroca.itens_devolvidos = this.getProdutosTroca;

        this.salvarTrocaVenda({
          troca: this.getTroca,
          venda: this.getVenda,
        });

        return;
      }

      if (this.getVenda.id) {
        this.atualizarVenda(this.getVenda).then(() => {
          this.acrescimosAplicados = [];
        });
      } else {
        this.getVenda.created_at = this.created_at
        this.salvarVenda(this.getVenda).then(() => {
          this.acrescimosAplicados = [];
        });

        this.$nextTick(() => {
          this.created_at = moment().format('YYYY-MM-DD')
        })
      }
    },
    pesquisarProdutoPorCodigoDeBarras() {
      if (!this.codigo_barras || this.codigo_barras == "undefined" || this.codigo_barras == null) {
        // console.log('codigo barras', this.codigo_barras)
        // document.getElementById("codigo_cliente").focus();
        return;
      }

      Produto.porCodigoDeBarras(this.codigo_barras)
        .then((res) => {
          if (this.codigo_barras) {
            if (res.data.id) {
              // if(res.data.grades.length > 0) {
              //   this.$store.commit('setProduto', res.data)
              //   this.setModalListarGradeProduto(true)
              // }
              this.setProdutoVenda(res.data);
              this.somaTotalItem();
              document.getElementById("quantidade").focus();
            } else {
              this.$store.commit("snackbarError", "Produto não encontado.");
              // this.codigo_barras = "";
              this.getProdutoVenda.descricao = "";
              this.getProdutoVenda.preco_venda = "0,00";
              this.quantidade = "1,00";
              this.desconto = "0,00";
              this.total = "0,00";
              document.getElementById("codigo_barra").focus();
            }
          }
        })
        .catch((e) => {
          this.codigo_barras = "";
          document.getElementById("codigo_barra").focus();
          this.$store.commit("snackbarError", "Erro ao pesquisar produto.");
          console.log(e);
        });
    },
    somaTotalItem() {
      this.subtotal = this.$helper.formatReal(
        this.$helper.cleanFormatReal(this.quantidade.toString()) *
          this.$helper.cleanFormatReal(this.getProdutoVenda.preco_venda)
      );
      this.total = this.subtotal;
    },
    verificaEstoque(item) {
      const estoque = item.estoques.filter(
        (data) => data.estoque.principal === true
      );
      if (estoque[0]) return estoque[0].quantidade;
    },
    addItemVenda() {
      if (!this.getProdutoVenda.id) {
        this.$store.commit("snackbarWarning", "Informe um produto.");
        return;
      }
      if (
        this.$helper.cleanFormatReal(this.desconto.toString()) >
        this.getProdutoVenda.desconto_maximo
      ) {
        this.$store.commit(
          "snackbarWarning",
          `O desconto máximo permitido é de ${this.getProdutoVenda.desconto_maximo} %`
        );
        return;
      }

      let item = {
        produto_id: this.getProdutoVenda.id,
        descricao: this.getProdutoVenda.descricao,
        preco: this.$helper.cleanFormatReal(this.getProdutoVenda.preco_venda),
        quantidade: parseFloat(
          this.quantidade.toString().replace(".", "").replace(",", ".")
        ),
        subtotal: this.$helper.cleanFormatReal(this.subtotal.toString()),
        desconto:
          this.$helper.cleanFormatReal(this.subtotal.toString()) -
          this.$helper.cleanFormatReal(this.total.toString()),
        total: this.$helper.cleanFormatReal(this.total),
        grade_id: this.getProdutoVenda.grade_id
      };

      this.addProdutoVenda(item);
      this.getVenda.desconto = this.$helper.formatReal(
        parseFloat(
          this.$helper.cleanFormatReal(this.getVenda.desconto.toString()) +
            item.desconto
        )
      );
      this.getProdutoVenda.preco_venda = this.$helper.formatReal(0);
      this.getProdutoVenda.descricao = null;
      this.total = "0,00";
      this.codigo_barras = null;
      this.quantidade = 1;
      this.getProdutoVenda.produto_id = null;
      this.getProdutoVenda.id = null;
      document.getElementById("codigo_barra").focus();
    },
    removerItemVenda(item) {
      this.getVenda.subtotal = this.$helper.formatReal(
        this.$helper.cleanFormatReal(this.getVenda.subtotal) - item.subtotal
      );
      this.getVenda.total = this.$helper.formatReal(
        this.$helper.cleanFormatReal(this.getVenda.total) - item.total
      );
      this.getVenda.desconto = this.$helper.formatReal(
        this.$helper.cleanFormatReal(this.getVenda.desconto) - item.desconto
      );
      this.$store.commit("removeProdutoVenda", item);
    },
    selecionaFormaPagamento() {
      document.getElementById("inputValorPago").focus();
    },
    adicionaDesconto() {
      document.getElementById("desconto_percentual").focus();
    },

    adicionaPagamento() {
      if (this.$helper.cleanFormatReal(this.getVenda.total) <= 0 && this.getProdutosVenda.length > 0) {
        this.modalSalvar = true;
        return
      }

      if (this.$refs.formFormaPagamento.validate() == false) {
        return;
      }

      this.valorFaltando = 0;
      if (
        !this.formaPagamentoSelecionadaValor ||
        this.formaPagamentoSelecionadaValor == "" ||
        this.$helper.cleanFormatReal(this.formaPagamentoSelecionadaValor) <= 0
      ) {
        this.$store.commit("snackbarWarning", "Informe o valor pago");
        return;
      }

      if (
        (this.formaPagamentoSelecionada.prazo && this.getContato.id == "") ||
        (this.formaPagamentoSelecionada.prazo && this.getContato.id == null) ||
        (this.formaPagamentoSelecionada.prazo && this.getContato.id == 1)
      ) {
        this.$store.commit(
          "snackbarWarning",
          "Informe um cliente para esta forma de pagamento."
        );
        this.formaPagamentoSelecionada = "";
        return;
      }

      if(this.formaPagamentoSelecionada.prazo && this.numero_parcelas < 1){
        this.$store.commit("snackbarWarning", "Informe o número de parcelas.");
        return
      }

      this.valorPago += this.$helper.cleanFormatReal(
        this.formaPagamentoSelecionadaValor
      );

      if (this.valorPago >= this.$helper.cleanFormatReal(this.getVenda.total)) {
        this.getVenda.troco = 0;
        this.getVenda.troco +=
          this.valorPago - this.$helper.cleanFormatReal(this.getVenda.total);
        this.modalSalvar = true;
      }

      if (this.valorPago < this.$helper.cleanFormatReal(this.getVenda.total)) {
        this.valorFaltando +=
          this.$helper.cleanFormatReal(this.getVenda.total) - this.valorPago;
      }

      if (this.valorPago > this.$helper.cleanFormatReal(this.getVenda.total)) {
        // this.trocoFormaPagamento = this.$helper.cleanFormatReal(this.formaPagamentoSelecionadaValor) - this.$helper.cleanFormatReal(this.getVenda.total)
        this.formaPagamentoSelecionadaValor = this.$helper.formatReal(
          this.$helper.cleanFormatReal(this.formaPagamentoSelecionadaValor) -
            this.getVenda.troco
        );
      }

      // return
      const data = {
        forma: this.formaPagamentoSelecionada.nome,
        valor_pago: this.formaPagamentoSelecionadaValor,
        troco: this.getVenda.troco,
        forma_pagamento_id: this.formaPagamentoSelecionada.id,
        forma_pagamento_nfe: this.formaPagamentoSelecionada.forma_pagamento_nfe,
        prazo: this.formaPagamentoSelecionada.prazo,
        bandeira_cartao: this.bandeira_cartao
          ? this.bandeira_cartao.nome
          : null,
        bandeira_pagamento_nfe: this.bandeira_cartao
          ? this.bandeira_cartao.id
          : null,
        numero_parcelas: this.numero_parcelas ? this.numero_parcelas : null,
        recorrencia: this.formaPagamentoSelecionada.recorrencia
          ? this.formaPagamentoSelecionada.recorrencia.dias
          : null,
        ocorrencia: this.formaPagamentoSelecionada.recorrencia
          ? this.formaPagamentoSelecionada.recorrencia.descricao
          : null,
        abate_credito_cliente: this.formaPagamentoSelecionada.abate_credito_cliente
      };

      if (this.valorPago > 0) {
        if (data.forma_pagamento_id) {
          this.getVenda.formas_pagamento.push(data);
        }
      }

      this.formaPagamentoSelecionada = {};
      this.formaPagamentoSelecionadaValor = "0,00";
      document.getElementById("inputFormaPagamento").focus();
      this.trocoFormaPagamento = 0;
    },
    aplicaDescontoItem() {
      if (this.desconto) {
        let subtotal = this.$helper.cleanFormatReal(this.subtotal.toString());
        let desconto =
          (this.$helper.cleanFormatReal(this.desconto.toString()) / 100) *
          subtotal;
        this.total = this.$helper.formatReal(parseFloat(subtotal - desconto));
      } else {
        this.total = this.subtotal;
      }
    },
    _buscarContato() {
      this.buscarContato(this.getContato.id);
    },
    verificarAcrescimo() {
      if (this.formaPagamentoSelecionada.acrescimo) {
        if (this.formaPagamentoSelecionada.acrescimo > 0) {
          this.modalAplicarAcrescimo = true;
        }
      }
    },
    aplicarAcrescimo() {
      if (
        (this.formaPagamentoSelecionada.prazo && this.getContato.id == "") ||
        (this.formaPagamentoSelecionada.prazo && this.getContato.id == null) ||
        (this.formaPagamentoSelecionada.prazo && this.getContato.id == 1)
      ) {
        this.$store.commit(
          "snackbarWarning",
          "Informe um cliente para esta forma de pagamento."
        );
        this.modalAplicarAcrescimo = false;
        this.formaPagamentoSelecionada = "";
        return;
      }

      this.modalAplicarAcrescimo = false;
      let indexAcrescimoAplicado = this.acrescimosAplicados.indexOf(
        this.formaPagamentoSelecionada
      );

      if (indexAcrescimoAplicado != -1) {
        this.$store.commit(
          "snackbarWarning",
          "O acréscimo dessa forma de pagamento já foi aplicado, selecione outra forma de pagamento."
        );
        this.modalAplicarAcrescimo = false;
        return;
      }

      if (
        this.$helper.cleanFormatReal(this.formaPagamentoSelecionada.acrescimo) >
        0
      ) {
        this.getVenda.total = this.$helper.formatReal(
          this.$helper.cleanFormatReal(this.getVenda.total) -
            this.getVenda.acrescimo
        );
        let valor_acrescimo =
          (parseFloat(this.formaPagamentoSelecionada.acrescimo) / 100) *
          this.$helper.cleanFormatReal(this.getVenda.total);
        this.getVenda.acrescimo += valor_acrescimo;
        this.getVenda.total = this.$helper.formatReal(
          this.$helper.cleanFormatReal(this.getVenda.total) +
            this.getVenda.acrescimo
        );
        this.acrescimosAplicados.push(this.formaPagamentoSelecionada);
      }
    },
    cancelarFechamento() {
      this.modalCancelarFechamento = false;
      this.formaPagamentoSelecionada = "";
      this.getVenda.formas_pagamento = [];
      this.getVenda.total = this.$helper.formatReal(
        this.$helper.cleanFormatReal(this.getVenda.total) -
          this.getVenda.acrescimo
      );
      this.getVenda.acrescimo = 0;
      this.acrescimosAplicados = [];
      this.valorPago = 0;
      this.getVenda.troco = 0;
      this.valorFaltando = 0;
    },
    fecharVenda() {
      this.getVenda.formas_pagamento = [];
      this.getVenda.troco = 0;
      this.valorPago = 0;
      this.valorFaltando = this.getVenda.total;
      if (this.getProdutosVenda.length == 0) {
        this.$store.commit(
          "snackbarError",
          "Inclua produtos para efetuar o fechamento."
        );
        return;
      }

      if (!this.getFuncionario.id) {
        this.$store.commit("snackbarError", "Selecione um vendedor.");
        return;
      }
      this.modalFechamento = true;
      setTimeout(() => {
        document.getElementById("inputFormaPagamento").focus();
      });
    },
    focusPrecoUnitario() {
      document.getElementById("preco_unitario").focus();
    },
    focusDescontoPercentual() {
      document.getElementById("desconto_percentual").focus();
    },
    focusQuantidade() {
      setTimeout(() => {
        this.desconto = "";
        this.somaTotalItem();
        document.getElementById("quantidade").focus();
      }, 100);
    },
    focusDescontoUnitario() {
      document.getElementById("desconto_unitario").focus();
    },
    focusCodigoDeBarra() {
      document.getElementById("codigo_barra").focus();
    },
    focusValorPago() {
      document.getElementById("inputValorPago").focus();
      this.formaPagamentoSelecionadaValor = "";
    },
    focusRecorrencia() {
      document.getElementById("inputRecorrencia").focus();
    },
    focusNumeroParcelaPrazo() {
      document.getElementById("inputNumeroParcelasPrazo").focus();
    },
    focus(InputId) {
      document.getElementById(InputId).focus();
    },
    keyUp(e) {
      if (!e) e = window.event;
      let keyCode = e.keyCode || e.which;
      if (keyCode == 113) e.preventDefault();
      if (keyCode == 114) e.preventDefault();
      if (keyCode == 116) e.preventDefault();
      if (keyCode == 117) e.preventDefault();

      if (keyCode == 113 && this.getModalVisualizarVenda == false) {
        this.setModalPesquisarProdutosOrcamento(true);
      }

      if (keyCode == 114 && this.getModalVisualizarVenda == false) {
        this.setModalPesquisarContato(true);
      }

      if (keyCode == 116) {
        this.fecharVenda();
      }

      if (keyCode == 117) {
        this.setModalDescontoAdicionalVenda(true);
      }

      if (keyCode == 83) {
        if (this.modalSalvar) {
          this.salvar();
        }

        if (this.modalCancelarFechamento) {
          this.modalCancelarFechamento = false;
          this.modalFechamento = false;
          return;
        }

        if (this.modalAplicarAcrescimo) {
          this.aplicarAcrescimo();
          this.modalAplicarAcrescimo = false;
          return;
        }
      }

      if (keyCode == 78) {
        if (this.modalSalvar) {
          this.modalSalvar = false;
          this.cancelarFechamento();
        }

        if (this.modalCancelarFechamento) {
          this.modalCancelarFechamento = false;
        }

        if (this.modalAplicarAcrescimo) {
          this.modalAplicarAcrescimo = false;
        }
      }
    },
  },
  created() {
    if (this.getProdutoVenda.id) {
      this.somaTotalItem(this.getProdutoVenda);
    }

    // this.listarFuncionarios()

    this.setModalPesquisarProdutosOrcamento(false);
    this.setModalPesquisarContato(false);
    this.listarFormaPagamento();
    if (this.$route.params.id) {
      this.editarVenda(this.$route.params.id);
      this.setClienteVenda(this.$store.state.clienteVenda);
    } else {
      if (this.$route.name == "vendaCadastro") {
        this.getVenda.cliente_id = 1;
        this.cadastrarVenda();
      }
    }

    this.debouncedpesquisarProdutoPorCodigoDeBarras = _.debounce(
      this.pesquisarProdutoPorCodigoDeBarras,
      500
    );
    this.debouncedBuscarContato = _.debounce(this._buscarContato, 500);
    document.addEventListener("keydown", this.keyUp);
  },
  beforeMount() {
    setTimeout(() => {
      this.setDrawer(false);
    }, 100);

    this.total = 0;
  },
  beforeDestroy() {
    document.removeEventListener("keydown", this.keyUp);
    this.modalImprimir = false;
    this.$store.commit("setProdutosTroca", []);
  },
};
</script>
<style scoped>
.lock-button {
  pointer-events: auto;
}
.autocomplete-vendedor {
  width: 50px;
}
</style>
